import {
  AuthenticationDetails,
  CognitoUser,
  CognitoUserPool,
  CognitoUserSession,
} from "amazon-cognito-identity-js";

const poolData = {
  UserPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID!,
  ClientId: process.env.REACT_APP_COGNITO_APP_CLIENT_ID!,
};
const userPool = new CognitoUserPool(poolData);

/**
 * Sign in a user with username & password.
 * @returns the CognitoUserSession on success.
 */
export async function signInUser(
  username: string,
  password: string,
): Promise<CognitoUserSession> {
  return new Promise((resolve, reject) => {
    const user = new CognitoUser({ Username: username, Pool: userPool });
    const authDetails = new AuthenticationDetails({
      Username: username,
      Password: password,
    });
    user.authenticateUser(authDetails, {
      onSuccess: (session) => resolve(session),
      onFailure: (err) => reject(err),
    });
  });
}

/**
 * Get the currently signed-in Cognito user (if any).
 */
export function getCurrentUser() {
  return userPool.getCurrentUser();
}

/**
 * Fetch a fresh session (and ID token) for the current user.
 */
export function getSession(): Promise<CognitoUserSession> {
  return new Promise((resolve, reject) => {
    const user = getCurrentUser();
    if (!user) {
      return reject(new Error("Kein eingeloggter Benutzer"));
    }
    user.getSession((err: Error | null, session: null | CognitoUserSession) => {
      if (err || !session?.isValid()) {
        return reject(err || new Error("Session ungültig"));
      }
      resolve(session);
    });
  });
}

/**
 * Return the JWT ID token string.
 */
export async function getIdToken(): Promise<string> {
  const session = await getSession();
  return session.getIdToken().getJwtToken();
}

/**
 * Return the Cognito 'sub' claim (the user’s UUID).
 */
export async function getSub(): Promise<string> {
  const session = await getSession();
  return session.getIdToken().decodePayload().sub;
}
